import type {
  CampaignLeaderboardRequest,
  CampaignLeaderboardResponse,
  DynamicCampaign,
  DynamicCampaignSummary,
  UserDataResponse,
} from '../types';
import type { AxiosRequestConfig } from 'axios';

import { BASE_PROFILE_URL } from '@rango-dev/internal-profile/api';

import { httpService, strapiService } from '../services';

const requestConfig: AxiosRequestConfig = { withCredentials: true };

export async function getUserData(id: string, signal?: AbortSignal): Promise<UserDataResponse> {
  const { data } = await httpService.get<UserDataResponse>(
    `${BASE_PROFILE_URL}/campaigns/${id}/user-data`,
    {
      ...requestConfig,
      signal,
    },
  );

  return data;
}

export async function getCampaignLeaderboard(
  params: CampaignLeaderboardRequest,
  signal?: AbortSignal,
): Promise<CampaignLeaderboardResponse> {
  const { data } = await httpService.get<CampaignLeaderboardResponse>(
    `${BASE_PROFILE_URL}/campaigns/public/leaderboard`,
    {
      ...requestConfig,
      signal,
      params,
    },
  );

  return data;
}

export async function getDynamicCampaign(
  id: string,
  signal?: AbortSignal,
): Promise<DynamicCampaign> {
  const { data } = await strapiService.get<DynamicCampaign>(`/campaigns/${id}`, {
    ...requestConfig,
    signal,
  });

  return data;
}

export async function getAllDynamicCampaign(
  signal?: AbortSignal,
): Promise<DynamicCampaignSummary[]> {
  const { data } = await strapiService.get<DynamicCampaignSummary[]>(`/campaigns`, {
    ...requestConfig,
    signal,
  });

  return data;
}
